<template>

  <div class="s-slides">

    <div class="s-slides-nav">
      <ul class="s-slides-buttons">
        <li class="s-slides-button p-cta">About</li>
        <li class="s-slides-button p-cta">People</li>
        <li class="s-slides-button p-cta">Careers</li>
        <li class="s-slides-button p-cta">Contact</li>
      </ul>
      <span class="s-slides-line"></span>
    </div>

    <div class="s-slides-headings">
      <div class="s-slides-heading">
        <div class="s-slides-heading-inner">
          <h1 class="f-xl">
            <span class="f-xl-line">Global. Long-term.</span>
            <span class="f-xl-line">Focused.</span>
          </h1>
          <p class="f-rg">
            VR Capital is an alternative asset manager focused on distressed securities and event-driven/special situations investments with a strong historical orientation towards emerging markets.
          </p>
        </div>
      </div>
      <div class="s-slides-heading">
        <div class="s-slides-heading-inner">
          <h1 class="f-xl">
            <span class="f-xl-line">Longevity. Integrity.</span>
            <span class="f-xl-line">Passion.</span>
          </h1>
          <p class="f-rg">
            Our team is comprised of experienced, thoughtful and inquisitive investment and business professionals hailing from more than ten countries.
          </p>
        </div>
      </div>
      <div class="s-slides-heading">
        <div class="s-slides-heading-inner">
          <h1 class="f-xl">
            <span class="f-xl-line">Driven. Collaborative.</span>
            <span class="f-xl-line">Inquisitive.</span>
          </h1>
          <p class="f-rg">
            We seek to recruit and train only the best people, provide them with a challenging working environment and reward them for their success. Exceptional candidates are encouraged to submit information.
          </p>
        </div>
      </div>
      <div class="s-slides-heading">
        <div class="s-slides-heading-inner">
          <h1 class="f-xl">
            <span class="f-xl-line">Locations. Contacts.</span>
            <span class="f-xl-line">Inquiries.</span>
          </h1>
          <p class="f-rg">
            Inquire within for more information on our office locations and to request additional information.
          </p>
        </div>
      </div>
    </div>

    <div class="s-slides-links">
      <router-link class="s-slides-link" to="/about">About</router-link>
      <router-link class="s-slides-link" to="/people">People</router-link>
      <router-link class="s-slides-link" to="/careers">Careers</router-link>
      <router-link class="s-slides-link" to="/contact">Contact</router-link>
    </div>

    <div class="s-slides-images">
      <div class="s-slides-mask p-cta">
        <div class="s-slides-shape"></div>
        <img class="s-slides-image" src="~@/assets/images/header-about.jpg">
      </div>
      <div class="s-slides-mask p-cta">
        <div class="s-slides-shape"></div>
        <img class="s-slides-image" src="~@/assets/images/header-people.jpg">
      </div>
      <div class="s-slides-mask p-cta">
        <div class="s-slides-shape"></div>
        <img class="s-slides-image" src="~@/assets/images/header-careers.jpg">
      </div>
      <div class="s-slides-mask p-cta">
        <div class="s-slides-shape"></div>
        <img class="s-slides-image" src="~@/assets/images/header-contact.jpg">
      </div>
    </div>

    <div class="s-slides-arrow">
      <div @click="slideTo('prev')">
        <img src="/svg/arrow-left.svg" alt="arrow-left">
      </div>
      <div @click="slideTo('next')">
        <img src="/svg/arrow-right.svg" alt="arrow-right">
      </div>
    </div>

  </div>

</template>

<script>
import Slides from './slides';

let slides;

export default {
  mounted() {
    slides = new Slides();
    slides.init();
  },
  destroyed() {
    slides.destroy();
  },
  methods: {
    slideTo(direction) {
      const slideToEvent = new CustomEvent('customSlideTo', {
        detail: { direction },
      });

      window.dispatchEvent(slideToEvent);
    },
  },
};
</script>
